import { global_reasons_to_signup } from '../../utils/requests/contentstack/contentStackZodSchema';
import type { ReasonsToSignUpProps } from './ReasonsToSignUp';

export const reasonsToSignUpSchema =
  global_reasons_to_signup.transform<ReasonsToSignUpProps>(data => ({
    blocks: data.blocks.map<ReasonsToSignUpProps['blocks'][number]>(block => {
      return {
        title: block.title,
        illustration: block.illustration,
        description: block.description,
      };
    }),
    title: data.title,
  }));
